module.exports = __webpack_public_path__ + "img/USD.602993cf.png";